// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-6088074f] {\n  font-weight: bold;\n  font-size: 1.125rem;\n}\n.sub-title[data-v-6088074f] {\n  margin: 5px 0px 0px 5px;\n}\n.label[data-v-6088074f] {\n  font-weight: bold;\n}\n@media only screen and (max-width: 768px) {\n.label[data-v-6088074f],\n  .sub-title[data-v-6088074f] {\n    font-size: 0.8571rem;\n}\n.title[data-v-6088074f] {\n    font-size: 1rem;\n}\n}", ""]);
// Exports
module.exports = exports;
